// extracted by mini-css-extract-plugin
export default {"shadowed":"Portfolio_shadowed__BYrH4","noselect":"Portfolio_noselect__HSI9a","button1":"Portfolio_button1__sNlky","dark":"Portfolio_dark__spGgZ","white":"Portfolio_white__8E7Ip"};